document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initSelectorVariantes();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.transitionDelay = (i % 6) * 90 + 'ms';
    observer.observe(el);
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var animado = new WeakSet();
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animado.has(entry.target)) {
          animado.add(entry.target);
          animarContador(entry.target);
        }
      });
    },
    { threshold: 0.6 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function animarContador(el) {
  var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
  var duracion = 1400;
  var inicio = null;
  function paso(ts) {
    if (!inicio) inicio = ts;
    var progreso = Math.min((ts - inicio) / duracion, 1);
    var valor = Math.floor(progreso * fin);
    el.textContent = valor.toLocaleString('es-ES');
    if (progreso < 1) requestAnimationFrame(paso);
    else el.textContent = fin.toLocaleString('es-ES');
  }
  requestAnimationFrame(paso);
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.src = src;
      miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura--activa'); });
      mini.classList.add('mt-miniatura--activa');
    });
  });
}

function initSelectorVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var selectores = form.querySelectorAll('[data-mt-opcion]');
  if (!selectores.length) return;

  function opcionesSeleccionadas() {
    var seleccion = [];
    selectores.forEach(function (sel) {
      var activo = sel.querySelector('.mt-opcion-valor--activa');
      seleccion.push(activo ? activo.getAttribute('data-valor') : null);
    });
    return seleccion;
  }

  function buscarVariante(seleccion) {
    return variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === seleccion[i]; });
    });
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = buscarVariante(seleccion);
    var inputId = form.querySelector('input[name="id"]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    var precioEl = document.querySelector('[data-mt-precio]');
    if (!variante) {
      if (botonComprar) { botonComprar.disabled = true; botonComprar.textContent = form.getAttribute('data-texto-no-disponible') || 'No disponible'; }
      return;
    }
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoDinero(variante.price);
    if (botonComprar) {
      if (variante.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = form.getAttribute('data-texto-comprar') || 'Añadir al carrito';
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = form.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  function formatoDinero(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  form.querySelectorAll('[data-valor]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grupo = btn.closest('[data-mt-opcion]');
      grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('mt-opcion-valor--activa'); });
      btn.classList.add('mt-opcion-valor--activa');
      actualizar();
    });
  });

  actualizar();
}
